module.exports = __webpack_public_path__ + "img/BGFeatureMediaLayeredLight.a38047a7.jpg";